<div
  class="emd-map-root"
  tabindex="0"
  role="application"
  [attr.aria-label]="ariaLabel"
  (keydown)="onKeydown($event)"
  (blur)="onBlur()"
>
  <div #chart class="emd-map-svg"></div>

  <!-- Zoom controls. Kept as buttons so they are reachable without a pointer;
       styled to match the original in-SVG 169x36 bottom-right bar. -->
  <div class="emd-map-zoom-controls" *ngIf="!loading && hasData">
    <button type="button" class="emd-map-reset" (click)="resetZoom()" aria-label="Reset zoom">
      <svg viewBox="0 0 21 20" width="18" height="18" aria-hidden="true">
        <path fill="#1363DF" d="M16.3662 3.63824L17.0735 2.93138V2.93138L16.3662 3.63824ZM20 8V9C20.5523 9 21 8.55228 21 8H20ZM19.609 12.7773C19.7622 12.2466 19.4561 11.6923 18.9255 11.5392C18.3948 11.3861 17.8406 11.6921 17.6874 12.2227L19.609 12.7773ZM21 2C21 1.44772 20.5523 1 20 1C19.4477 1 19 1.44772 19 2H21ZM14 7C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9V7ZM0 10C0 15.5228 4.47715 20 10 20V18C5.58172 18 2 14.4183 2 10H0ZM10 0C4.47715 0 0 4.47715 0 10H2C2 5.58172 5.58172 2 10 2V0ZM17.0735 2.93138C15.2648 1.12139 12.7624 0 10 0V2C12.2104 2 14.2098 2.89514 15.6588 4.34511L17.0735 2.93138ZM15.6588 4.34511C16.4319 5.11872 17.3119 6.17306 18.0111 7.05263C18.3577 7.4887 18.6545 7.87487 18.8643 8.15174C18.9692 8.29008 19.0522 8.40091 19.1087 8.47676C19.1369 8.51468 19.1585 8.54384 19.1729 8.56331C19.1801 8.57304 19.1855 8.58035 19.189 8.58512C19.1908 8.58751 19.192 8.58925 19.1929 8.59035C19.1933 8.5909 19.1935 8.59129 19.1937 8.59151C19.1938 8.59162 19.1938 8.59169 19.1939 8.59172C19.1939 8.59174 19.1939 8.59173 19.1939 8.59173C19.1939 8.59172 19.1938 8.59169 20 8C20.8062 7.40831 20.8061 7.40826 20.8061 7.4082C20.8061 7.40817 20.806 7.4081 20.806 7.40803C20.8059 7.40789 20.8057 7.40771 20.8056 7.40749C20.8052 7.40705 20.8048 7.40644 20.8042 7.40567C20.8031 7.40413 20.8015 7.40194 20.7994 7.39911C20.7952 7.39344 20.7892 7.38521 20.7813 7.37454C20.7655 7.35319 20.7424 7.32207 20.7127 7.28211C20.6532 7.2022 20.5668 7.08687 20.4582 6.94364C20.2412 6.65737 19.9349 6.25871 19.5767 5.80809C18.8662 4.91428 17.9293 3.78774 17.0735 2.93138L15.6588 4.34511ZM10 20C14.5605 20 18.4055 16.9481 19.609 12.7773L17.6874 12.2227C16.7243 15.5605 13.6457 18 10 18V20ZM19 2V8H21V2H19ZM20 7H14V9H20V7Z"/>
      </svg>
    </button>

    <div class="emd-map-zoom-panel">
      <button type="button" class="emd-map-zoom-chip" (click)="zoomOut()" aria-label="Zoom out">
        <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">
          <!-- Centred minus bar, matching the plus's horizontal arm (was drawn
               at the top-left of the viewBox, so it sat misaligned vs the +). -->
          <rect fill="#fff" x="0" y="8.18" width="20" height="3.64" rx="1.36" />
        </svg>
      </button>

      <span class="emd-map-zoom-value">{{ zoomPercent }}%</span>

      <button type="button" class="emd-map-zoom-chip" (click)="zoomIn()" aria-label="Zoom in">
        <svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">
          <path fill="#fff" d="M18.6364 8.18184H11.8182V1.36364C11.8182 0.610908 11.2073 0 10.4545 0H9.54548C8.79275 0 8.18184 0.610908 8.18184 1.36364V8.18184H1.36364C0.610908 8.18184 0 8.79275 0 9.54548V10.4545C0 11.2073 0.610908 11.8182 1.36364 11.8182H8.18184V18.6364C8.18184 19.3891 8.79275 20 9.54548 20H10.4545C11.2073 20 11.8182 19.3891 11.8182 18.6364V11.8182H18.6364C19.3891 11.8182 20 11.2073 20 10.4545V9.54548C20 8.79275 19.3891 8.18184 18.6364 8.18184Z"/>
        </svg>
      </button>
    </div>
  </div>

  <emd-chart-states
    [loading]="loading"
    [empty]="!loading && !hasData"
    variant="map"
    message="No locations for the selected filters"
  ></emd-chart-states>

  <emd-chart-tooltip
    [visible]="tooltipVisible"
    [title]="tooltipTitle"
    [rows]="tooltipRows"
    [x]="tooltipX"
    [y]="tooltipY"
    [hostWidth]="width"
    [hostHeight]="height"
  ></emd-chart-tooltip>
</div>
